import LitterInfoOk from '../action-types/listingLitterInfoOk';

const initialState = true;

const LitterInfoOkReducer = (state = initialState, action) => {
  switch (action.type) {
    case LitterInfoOk.SET_LITTER_INFO_OK: {
      const { infoIsOk } = action;
      return infoIsOk;
    }
    default:
      return state;
  }
};

export default LitterInfoOkReducer;
